<template>
  <div class="groupList">
    <header class="fixed_detail_header flx">
    <div class="menu flx">
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#000" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
      <h3>{{$t('groupOnProduct')}}</h3>
    </div>
    <div class="create_group" @click="openGroupterms = !openGroupterms"
          :class="{'visibilityHidden' : isGroupCreated}">
      <i class="material-icons">group_add</i>
          <span>{{$t('createGroup')}}</span>
    </div>
  </header>
    <section class="detail_content gryBack">
      <CreatedProductGroup :groupValue="existGroup" />
      <GroupTerms v-if="openGroupterms" @closeGroupTerms="closeGroupterms" :minOrderData="minOrderId"  />
      <infinite-loading @infinite="existingGroup" spinner="circles">
        <template slot="no-more">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    </section>
    <div class="loader" v-if="loading">
      <img src="../../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import CreatedProductGroup from "../ProductDetailTab/CreatedProductGroup";
import GroupTerms from "../ProductDetailTab/GroupTerms";
export default {
  name: "GroupList",
  components: {
    CreatedProductGroup,
    GroupTerms
  },
  data() {
    return {
      details: {},
      openGroupterms: false,
      existGroup: [],
      groupIndex: 0,
      isGroupCreated: false,
      minOrderId: '',
      loading: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    closeGroupterms(value) {
      this.openGroupterms = value;
    },

    // to get group listing need productId and itemId is for Create shopping group
    existingGroup($state) {
      const obj = {
        productId: this.$route.query.productId,
        pageIndex: this.groupIndex
      };
      this.$store
        .dispatch({
          type: "getGroup",
          payload: obj
        })
        .then(data => {
          this.loading = false
          if (data.data.groupSocialInfoDTO.length) {
            if (this.groupIndex == 0) {
              this.isGroupCreated = data.data.isGroupCreatedByUser;
              this.minOrderId = data.data.groupSocialInfoDTO[0].minOrdersToFormNewGroup;
            }
            this.groupIndex += 1;
            this.existGroup.push(...data.data.groupSocialInfoDTO);
            this.$store.commit("saveGroupData", {
              groupListData: this.existGroup,
              groupIndex: this.groupIndex + 1
            });
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
        })
        .catch(err => {
          console.log(err)
        });
    }
  },
   mounted(){
    this.loading = true
  }
};
</script>
